import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Card, CardContent } from './ui/Card';
interface Testimonial {
  name: string;
  role: string;
  content: string;
  rating: number;
}
interface TestimonialsProps {
  items: Testimonial[];
}
export function Testimonials({
  items
}: TestimonialsProps) {
  return <section className="bg-slate-50 py-20 lg:py-32 relative overflow-hidden" data-id="element-249">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(#3b82f6_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-250"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-251">
        <div className="mx-auto max-w-3xl text-center mb-16" data-id="element-252">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl md:text-5xl mb-6" data-id="element-253">
            Vertrauen ist unsere Währung
          </h2>
          <p className="text-xl text-slate-600" data-id="element-254">
            Sehen Sie, warum über 50.000 Kunden SmartProtect24 für ihre
            finanzielle Sicherheit wählen.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3" data-id="element-255">
          {items.map((item, index) => <Card key={index} className="border-none shadow-lg hover:shadow-xl transition-all duration-300 bg-white/80 backdrop-blur-sm" data-id="element-256">
              <CardContent className="p-8" data-id="element-257">
                <div className="flex justify-between items-start mb-6" data-id="element-258">
                  <div className="flex gap-1" data-id="element-259">
                    {[...Array(5)].map((_, i) => <Star key={i} className={`h-4 w-4 ${i < item.rating ? 'text-amber-400 fill-amber-400' : 'text-slate-200'}`} data-id="element-260" />)}
                  </div>
                  <Quote className="h-8 w-8 text-blue-100 fill-blue-50" data-id="element-261" />
                </div>

                <p className="mb-8 text-slate-700 italic text-lg leading-relaxed" data-id="element-262">
                  "{item.content}"
                </p>

                <div className="flex items-center pt-6 border-t border-slate-100" data-id="element-263">
                  <div className="h-12 w-12 rounded-full bg-gradient-to-br from-blue-100 to-indigo-100 flex items-center justify-center text-blue-700 font-bold text-lg shadow-inner" data-id="element-264">
                    {item.name.charAt(0)}
                  </div>
                  <div className="ml-4" data-id="element-265">
                    <p className="text-base font-bold text-slate-900" data-id="element-266">
                      {item.name}
                    </p>
                    <p className="text-sm text-slate-500 font-medium" data-id="element-267">
                      {item.role}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}